import { render, staticRenderFns } from "./UpdateIdentityVerifyModal.vue?vue&type=template&id=1293d130&scoped=true&"
import script from "./UpdateIdentityVerifyModal.vue?vue&type=script&lang=js&"
export * from "./UpdateIdentityVerifyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1293d130",
  null
  
)

export default component.exports